import React, { Component } from 'react'
import Modal from 'react-modal';
import styles from '../Report/Report.less';
import deliveryStyles from './Delivery.less';
import i18next from 'i18next';
import { Button } from 'react-bootstrap';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import { connect } from 'react-redux';
import * as commonActions from '../../actions/commonActions';

@connect(state => ({
}), {
    ...commonActions
})

export default class CancelRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelReason: '',
      rowData: props.rowData || {},
      showError: false
    };
  }

  handleCloseIconClick = () => {
    this.props.onClose();
  };

  handleReasonChange = (e) => {
    this.setState({
      cancelReason: e.target.value,
      showError: false
     });
  };

  handleSubmit = () => {
    const { cancelReason } = this.state;

    if (!cancelReason.trim()) {
      this.setState({ showError: true });
      return;
    }

    const cancelRequestPayload = {
      DOC: this.state.rowData.DRN,
      RMK: cancelReason,
      TRID: this.state.rowData.TRID,
    };

    this.props.cancelDeliveryRequest(cancelRequestPayload);

    this.props.onSubmit?.(cancelReason);
    console.log("Submit:", cancelReason)
    this.props.onClose();

  };

  componentWillUpdate(nextProps) {
    if (this.props.rowData !== nextProps.rowData) {
      this.setState({ rowData: nextProps.rowData });
    }
  }

  render() {
    const { isOpen, onClose } = this.props;
    const { cancelReason, rowData } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="Cancel Request"
        closeTimeoutMS={350}
        className={`${deliveryStyles.delModals} ${deliveryStyles.cancelReqModal}`}
        overlayClassName="overlay"
        shouldCloseOnOverlayClick={false}
      >
        <div className={`${styles.reporthead} ${deliveryStyles.modalHeader} reportheader`}>
          <label className="rptHeader">Cancel Delivery Request</label>
          <span onClick={this.handleCloseIconClick} id="closeCancelReqModal" className={`${styles.closeIcon} closeIcon commonCloseIcon`}>
            <MUIIconWithTooltip icon={"Close"} className={"closeBtn"} title={i18next.t("close")} />
          </span>
        </div>

        <div className={deliveryStyles.modalBody}>
          <div className="row">
            <div className="col-12">
              <p className={deliveryStyles.cancelReqConfMsg}>Are you sure you want to cancel the delivery request - <strong>{rowData?.DRN}</strong></p>
            </div>

            <div className="col-12">
              <em>
                <label>Note:</label>
                <ul>
                  <li>Cancellation charges will be applied.</li>
                  <li>Cancellation charges will be applied.</li>
                </ul>
              </em>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <label>Reason for Cancellation <span className="mndt">*</span></label>
              <textarea className="form-control" value={cancelReason} onChange={this.handleReasonChange} />
              {this.state.showError && (
                <p className={deliveryStyles.cancelReasonError}>
                  Please enter a reason for cancellation.
                </p>
              )}
            </div>
          </div>
        </div>

        <div className={deliveryStyles.modalFooter}>
          <Button onClick={this.handleSubmit} className={`${deliveryStyles.submitBtn} savebutton`}>{i18next.t("submit")}</Button>
        </div>
      </Modal>
    );
  }
}
